import { render, staticRenderFns } from "./Secession.vue?vue&type=template&id=6e3d6d6a&"
import script from "./Secession.vue?vue&type=script&lang=js&"
export * from "./Secession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports